// extracted by mini-css-extract-plugin
export var actions = "_sx-4";
export var item = "_sx-1";
export var price = "_sx-3";
export var quantity = "_sx-2";
export var table = "_sx-0";